import React, { useEffect } from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { ErrorCodes } from 'liveReportService'
import { useDisplayTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'
import ErrorMessage from 'components/share/ErrorMessage'
import ScreenSpinner from 'components/share/ScreenSpinner'
import { useLiveReportAuth } from '../hooks'

const Container = styled.div<{ mode: Theme }>`
  height: 100vh;
  background-color: ${({ mode }) => sys[mode].elevation[100].background};
`

const CsrfTokenHandler = ({ children }: { children: React.ReactElement }) => {
  const displayTheme = useDisplayTheme()
  const {
    retrieveCsrfToken,
    csrfToken: { status, error },
    notifySessionInvalid
  } = useLiveReportAuth()

  useEffect(() => {
    retrieveCsrfToken()
  }, [retrieveCsrfToken])

  useEffect(() => {
    if (error?.status === ErrorCodes.SessionKicked) {
      notifySessionInvalid()
    }
  }, [error, notifySessionInvalid])

  if (status === 'idle' || status === 'loading') {
    return <ScreenSpinner />
  }

  if (status === 'failed') {
    return (
      <Container mode={displayTheme}>
        <ErrorMessage />
      </Container>
    )
  }

  return children
}

export default CsrfTokenHandler
